import React, { useState } from 'react';
import { Instagram, Mail, MapPin } from 'lucide-react';
import { LegalModal } from './LegalModal';

export const Footer = () => {
  const [legalModal, setLegalModal] = useState({ isOpen: false, type: null });

  const openLegal = (type) => {
    setLegalModal({ isOpen: true, type });
  };

  const closeLegal = () => {
    setLegalModal({ isOpen: false, type: null });
  };

  return (
    <>
      <LegalModal 
        isOpen={legalModal.isOpen} 
        onClose={closeLegal} 
        type={legalModal.type} 
      />
    <footer className="bg-[#071936] text-white py-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-12 mb-12 max-w-7xl mx-auto">
          {/* Brand */}
          <div className="md:col-span-5">
            <h3 className="text-xl font-medium mb-4">
              The Tullaghan Pod
            </h3>
            <p className="text-white/70 leading-relaxed mb-6 max-w-md">
              A cosy glamping retreat on Ireland's Wild Atlantic Way, with sea views, a wood-fired hot tub, and a warm welcome from Caroline and Joe.
            </p>
            <a
              href="https://www.instagram.com/tullaghan_pod"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#2AA7A1] hover:text-white transition-colors group"
            >
              <Instagram size={20} />
              <span>@tullaghan_pod</span>
            </a>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-sm uppercase tracking-wider text-white/60 mb-4 font-medium">Explore</h4>
            <ul className="space-y-3">
              {['The Pod', 'Gallery', 'Amenities', 'Location', 'Reserve'].map((link) => (
                <li key={link}>
                  <button
                    onClick={() => {
                      const id = link.toLowerCase().replace('the pod', 'about').replace('reserve', 'booking').replace(' ', '');
                      const element = document.getElementById(id);
                      if (element) {
                        const navHeight = 80;
                        const targetPosition = element.getBoundingClientRect().top + window.pageYOffset - navHeight;
                        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
                      }
                    }}
                    className="text-white/70 hover:text-white transition-all duration-300 text-sm group inline-flex items-center"
                  >
                    <span className="relative">
                      {link}
                      <span className="absolute bottom-0 left-0 w-0 h-[1px] bg-white transition-all duration-300 group-hover:w-full"></span>
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="text-sm uppercase tracking-wider text-white/60 mb-4 font-medium">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="text-[#2AA7A1] flex-shrink-0 mt-1" size={18} />
                <span className="text-white/70 text-sm leading-relaxed">
                  Tullaghan, County Leitrim<br />Ireland
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="text-[#2AA7A1] flex-shrink-0" size={18} />
                <a href="mailto:tullaghanpodco@gmail.com" className="text-white/70 hover:text-white transition-colors text-sm">
                  tullaghanpodco@gmail.com
                </a>
              </li>
            </ul>
            <p className="text-sm text-white/50 mt-6">
              Direct booking enquiries welcome
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} The Tullaghan Pod. All rights reserved.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 text-sm text-white/50">
            <div className="flex gap-8">
              <button onClick={() => openLegal('privacy')} className="hover:text-white transition-colors">Privacy</button>
              <button onClick={() => openLegal('terms')} className="hover:text-white transition-colors">Terms</button>
              <button onClick={() => openLegal('cookies')} className="hover:text-white transition-colors">Cookies</button>
            </div>
            <span className="hidden sm:inline text-white/30">·</span>
            <a 
              href="https://www.directstay.ie" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/50 hover:text-white transition-colors duration-300 hover:underline"
            >
              Designed by DirectStay
            </a>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
};
